import React, {useState, useEffect} from "react";
import {useObserver} from "mobx-react-lite";
import {Skeleton, Tabs} from "antd";
import {useHistory, useLocation} from "react-router-dom";

import {SubcompanyIntegrationList} from "../subCompanyDetail/subcompanyIntegrationList/SubcompanyIntegrationList";
import {SubcompanyMealCardIntegrationList} from "../subCompanyDetail/subcompanyMealCardIntegrationList/SubcompanyMealCardIntegrationList";
import {SubcompanyCredit} from "../subCompanyDetail/subcompanyCredit/SubcompanyCredit";
import {SubcompanyBilling} from "../subCompanyDetail/subcompanyBilling/SubcompanyBilling";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {TabsContainer} from "../../courier/courierDetail/courierDetailStyles";
import {SubCompanyDetailTab} from "./subCompanyDetailTab/SubCompanyDetailTab";
import {CariRecordTab} from "./cariRecordTab/CariRecordTab";
import {UsersTab} from "./usersTab/UsersTab";
import {SubCompanySalesTab} from "./subCompanySalesTab/SubCompanySalesTab";
import SubcompanyPayments from "../subCompanyDetail/subcompanyPayments/SubcompanyPayments";
import {SubcompanyCodPaymentSettings} from "./subcompanyCodPaymentSettings/SubcompanyCodPaymentSettings";
import {ContractsTab} from "./contractsTab/ContractDetailTab";

export const SubCompanyDetailWithTab = ({subCompanyId}) => {
    const stores = useStore();
    const [recall, setRecall] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const validTabKeys = [
        "subCompanyDetail",
        "billing",
        "cariRecords",
        "credit",
        "users",
        "integrations",
        "mealCardIntegrations",
        "sales",
        "payments",
        "vigoPos",
        "contracts"
    ];

    const currentTab = searchParams.get("tab");
    const [tabKey, setTabKey] = useState(
        validTabKeys.includes(currentTab) ? currentTab : "subCompanyDetail"
    );

    useEffect(() => {
        if (currentTab && !validTabKeys.includes(currentTab)) {
            searchParams.delete("tab");
            history.replace({
                pathname: location.pathname,
                search: searchParams.toString()
            });
        }
    }, [currentTab]);

    const [loading, subCompany, setSubCompany, setLoading, refetch] = useFetch({
        fetchFn: stores.companyStore.getSubCompany.bind(null, {subCompanyId}),
        showLoading: true,
        condition: !!subCompanyId,
        dependencies: [recall, subCompanyId],
        initialCall: true
    });

    const [loadingCaris, subCompanyCaris] = useFetch({
        fetchFn: stores.companyStore.getSubCompanyCaris.bind(null, {subCompanyId}),
        showLoading: true,
        condition: !!subCompanyId
    });

    const handleTabChange = key => {
        setTabKey(key);
        searchParams.set("tab", key);
        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    };

    return useObserver(() =>
        !subCompany.data ? (
            <Skeleton paragraph={{rows: 10, width: "100%"}} active={true}></Skeleton>
        ) : (
            <>
                <TabsContainer activeKey={tabKey} onChange={handleTabChange}>
                    <Tabs.TabPane tab={<span>Alt Firma Detayı</span>} key="subCompanyDetail">
                        <SubCompanyDetailTab
                            subcompanyId={subCompanyId}
                            subCompany={subCompany}
                            recall={() => setRecall(!recall)}
                        />
                    </Tabs.TabPane>
                    {stores.meStore.checkRole("subcompany.bilingDetail") && (
                        <Tabs.TabPane tab={<span>Cari Bilgileri</span>} key="billing">
                            <SubcompanyBilling
                                subCompany={subCompany?.data}
                                subcompanyId={subCompanyId}
                                style={{marginBottom: "40px"}}
                                refetch={refetch}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.cariRecordsDetail") && (
                        <Tabs.TabPane tab={<span>Cari Kayıtları</span>} key="cariRecords">
                            <CariRecordTab subCompanyCaris={subCompanyCaris} />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.creditDetail") && (
                        <Tabs.TabPane tab={<span>Kredi</span>} key="credit">
                            <SubcompanyCredit
                                subcompanyId={subCompanyId}
                                style={{marginBottom: "40px"}}
                                recall={() => setRecall(!recall)}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.usersDetail") && (
                        <Tabs.TabPane tab={<span>Kullanıcılar</span>} key="users">
                            <UsersTab subcompanyId={subCompanyId} />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.integrationList") && (
                        <Tabs.TabPane tab={<span>Entegrasyonlar</span>} key="integrations">
                            <SubcompanyIntegrationList
                                subcompanyId={subCompanyId}
                                style={{marginBottom: "40px"}}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.mealCardIntegrations") && (
                        <Tabs.TabPane
                            tab={<span>Yemek Kartı Entegrasyonları</span>}
                            key="mealCardIntegrations"
                        >
                            <SubcompanyMealCardIntegrationList
                                subcompanyId={subCompanyId}
                                style={{marginBottom: "40px"}}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.salesDetail") && (
                        <Tabs.TabPane tab={<span>Satışlar</span>} key="sales">
                            <SubCompanySalesTab
                                subcompanyId={subCompanyId}
                                subCompany={subCompany}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.paymentsDetail") && (
                        <Tabs.TabPane tab={<span>Ödemeler (Dedike)</span>} key="payments">
                            <SubcompanyPayments
                                subcompanyId={subCompanyId}
                                style={{marginBottom: "40px"}}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.vigoPosDetail") && (
                        <Tabs.TabPane tab={<span>VigoPOS</span>} key="vigoPos">
                            <SubcompanyCodPaymentSettings
                                subCompany={subCompany?.data || {}}
                                tabKey={tabKey}
                                recall={() => setRecall(!recall)}
                            />
                        </Tabs.TabPane>
                    )}
                    {stores.meStore.checkRole("subcompany.contractsDetail") && (
                        <Tabs.TabPane tab={<span>Sözleşmeler</span>} key="contracts">
                            <ContractsTab
                                subCompanyId={subCompanyId}
                                recall={recall}
                                setRecall={() => {
                                    setRecall(!recall);
                                }}
                            />
                        </Tabs.TabPane>
                    )}
                </TabsContainer>
            </>
        )
    );
};
